import { FilterBar, SearchInput, Select } from './styled';

interface CounterpartyFilterBarProps {
  search: string;
  onSearchChange: (val: string) => void;
  typeFilter: string;
  onTypeFilterChange: (val: string) => void;
  sourceFilter: string;
  onSourceFilterChange: (val: string) => void;
  sourceChoices: Array<{ code: string; label: string }>;
  requisitesFilter: string;
  onRequisitesFilterChange: (val: string) => void;
}

export function CounterpartyFilterBar({
  search,
  onSearchChange,
  typeFilter,
  onTypeFilterChange,
  sourceFilter,
  onSourceFilterChange,
  sourceChoices,
  requisitesFilter,
  onRequisitesFilterChange,
}: CounterpartyFilterBarProps) {
  return (
    <FilterBar>
      <SearchInput
        type="search"
        aria-label="Поиск контрагента"
        placeholder="Поиск по наименованию, ИНН, БИК или номеру счёта…"
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
      />
      <Select
        aria-label="Тип контрагента"
        value={typeFilter}
        onChange={(e) => onTypeFilterChange(e.target.value)}
      >
        <option value="all">Все типы контрагентов</option>
        <option value="supplier">Поставщики</option>
        <option value="subcontractor">Субподрядчики</option>
        <option value="customer">Заказчики</option>
        <option value="leasing">Лизинговые компании</option>
        <option value="bank">Банки</option>
        <option value="tax_authority">ФНС / Налоги</option>
        <option value="other">Прочее</option>
      </Select>
      <Select
        aria-label="Источник карточки"
        value={sourceFilter}
        onChange={(e) => onSourceFilterChange(e.target.value)}
      >
        <option value="all">Все источники</option>
        {sourceChoices.map((s) => (
          <option key={s.code} value={s.code}>
            {s.label}
          </option>
        ))}
      </Select>
      <Select
        aria-label="Реквизиты для платёжки"
        value={requisitesFilter}
        onChange={(e) => onRequisitesFilterChange(e.target.value)}
      >
        <option value="all">Все по реквизитам</option>
        <option value="complete">Реквизиты полные</option>
        <option value="incomplete">Требуют уточнения</option>
      </Select>
    </FilterBar>
  );
}
